<template>
  <div>
    <div class='fixed-navbar' :class="{ 'navbar-fixed': isNavbarFixed }">
      <el-card shadow='never' class='navbar-card'>
        <div class='navbar-content'>
          <navBar class='navbar-left' :categoryType='2' :is-type='2' />
          <div class='navbar-center'>
            {{ this.$utils.parseTime(this.info.start_at, '{y}年{m}月{d}日') }}
            【{{ this.info.nickname }}】{{ this.info.platform_name }} 直播定品详情
            <span class='status-label' :style='statusLabelStyle'>
              {{ progressStatusAliasMap[info.progress_status] || '--' }}
            </span>
          </div>
          <div class='navbar-right' v-if="userPermissions.indexOf('lb_live_log')>-1">
            <el-button
              size='small'
              type='primary'
              icon='el-icon-document'
              @click='showLogDialog = true'>
              操作日志
            </el-button>
            <el-button size='small' plain icon='el-icon-delete' type='danger' @click='handleDelete(info)'
                       :disabled='!canEdit'>删除排期
            </el-button>

          </div>
        </div>
      </el-card>
    </div>
    <div class='main-page-content'>
      <div style='padding: 10px'>
        <!--        基本信息-->
        <div v-if='id&&userPermissions.indexOf("lb_live_info")>-1' style='padding-top: 10px'>
          <lb-info :infoRow='info' @close='getInfo'></lb-info>
        </div>
      </div>
      <!--      选品列表-->
      <div style='margin-top: 10px' v-if='userPermissions.indexOf("lb_live_selection")>-1'>
        <el-divider content-position='left'>
          <span style='color:#ff3176 '>【美护】</span>

          直播定品表
        </el-divider>
        <!--      直播选品页面-->
        <SelectionLive :id='id' :show-header='false' v-if='userPermissions.indexOf("lb_live_selection_list")>-1&&id' />
      </div>

    </div>

    <!--    创建直播排期-->
    <CreateEdit :visible.sync='open' :id='id' @close='getInfo' v-if='userPermissions.indexOf("lb_live_edit")>-1&&id' />

    <!--    操作日志对话框-->
    <el-dialog
      title='日志查看'
      :visible.sync='showLogDialog'
      width='50%'>
      <div class='log-dialog-content'>
        <LogList
          ref='refLog'
          :info-id='id'
          v-if='showLogDialog && id' />
      </div>
    </el-dialog>
  </div>
</template>

<script>


import CreateEdit from './CreateEdit'
import LbScheduleLog from '@/pages/lb/LbScheduleLog'
import LogList from '@/pages/lb/components/LogList'
import { mapGetters } from 'vuex'
import ExportBtn from '@/components/export/ExportBtn'
import SelectionLive from '@/pages/lb/live/SelectionLive'
import navBar from '@/pages/lb/components/navBar.vue'
import lbInfo from './components/lbInfo.vue'

export default {
  name: 'LiveDetail',
  components: {
    lbInfo,
    navBar,
    SelectionLive,
    ExportBtn,
    LogList,
    LbScheduleLog,
    CreateEdit
  },
  computed: {
    ...mapGetters(['userPermissions', 'userInfo']),
    canEdit() {
      return (this.userPermissions.indexOf('lb_schedule_edit_leader') > -1 || this.info.leader_id === this.userInfo.id)
    },
    progressStatusMap() {
      const map = {}
      this.progressStatusOptions.forEach((item) => {
        map[item.value] = item.class_name
      })
      return map
    },
    progressStatusAliasMap() {
      const map = {}
      this.progressStatusOptions.forEach((item) => {
        map[item.value] = item.label
      })
      return map
    },
    progressStatusColorMap() {
      const map = {}
      this.progressStatusOptions.forEach((item) => {
        map[item.value] = item.color_value
      })
      return map
    },
    statusLabelStyle() {
      return {
        fontSize: '14px',
        textAlign: 'center',
        borderRadius: '5px',
        padding: '2px 8px',
        margin: '1px',
        border: '#7d8086 1px solid',
        backgroundColor: this.progressStatusColorMap[this.info.progress_status]
      }
    }
  },
  data() {
    return {
      id: null,
      info: {},
      dataList: [],
      isTable: false,
      progress_status: 1,
      open: false,
      openImport: false,
      openDemandConfirm: false,
      showLogDialog: false,
      isNavbarFixed: false,
      progressStatusOptions: [
        { label: '新创建', value: 1, color_value: '#FFFFFF', class_name: 'status-new' },
        { label: '已发需求', value: 2, color_value: '#67C23A', class_name: 'status-launch' },
        { label: '初选完成', value: 3, color_value: '#409EFF', class_name: 'status-original' },
        { label: '确认完成', value: 4, color_value: '#E6A23C', class_name: 'status-ack' },
        { label: '锁定表格', value: 5, color_value: '#F56C6C', class_name: 'status-lock' }
      ],
      showSelectionCard: false


    }
  },
  methods: {
    init() {
      this.getInfo()
    },
    /**
     * 检测页面滚动位置
     */
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.isNavbarFixed = scrollTop > 100
    },
    /**
     * 初始化滚动监听
     */
    initScrollListener() {
      window.addEventListener('scroll', this.handleScroll)
    },
    /**
     * 移除滚动监听
     */
    removeScrollListener() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    async getInfo() {
      const { info } = await this.$api.getLbScheduleInfo(this.id)
      this.info = info
      this.progress_status = info.progress_status
      this.$nextTick(() => {
        this.dataList = [info]
        document.title = `【${info.nickname}】直播定品`

        // console.log(this.dataList)
      })
    },
    handleEdit() {
      this.open = true
    },
    async commitDemand() {
      this.openDemandConfirm = true
      // await this.$api.launchLbSchedule(this.id)
      // await this.init()
    },
    jumpToPage(pageName, query) {
      this.$router.push({
        name: pageName,
        query: query
      })
      // const { href } = this.$router.resolve({
      //   name: pageName,
      //   query: query
      // })
      // window.open(href, '_blank')
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const id = row.id
      this.$confirm(`确认【删除】排期（${this.$utils.parseTime(row.start_at, '{y}-{m}-{d}')}【${row.nickname}】${row.platform_name}）及选品？ 注：删除后可在回收站恢复`, '警告', {
        confirmButtonText: '确定删除',
        cancelButtonText: '再想想',
        type: 'warning'
      }).then(() => {
        this.delInfo(id)
      }).catch(() => {
        this.msgWarn('取消操作')
      })
    },
    async delInfo(id) {
      const info = await this.$api.delLbSchedule(id)
      if (info) {
        this.msgSuccess('删除成功')
        this.$router.push({
          name: 'LbScheduleLive'
        })
      }
    },
    handleRouter() {
      const params = {
        id: this.id
      }

      const { href } = this.$router.resolve({
        name: 'productDressLive',
        params: params
      })
      window.open(href, '_blank')
    }
  },
  mounted() {
    this.initScrollListener()
  },
  created() {
    this.id = this.$route.params.id || this.$route.query.id
    this.getInfo()
  },
  beforeDestroy() {
    this.removeScrollListener()
  }
}
</script>

<style scoped>
.title {
  font-size: 16px;
  font-weight: bold;
}

.box-progress {
  width: 90%;
  padding: 10px;
  height: 100px;
  /*line-height: 100px;*/
  border: 1px solid #000c17;
  border-radius: 5px;
  /*margin-bottom: 10px;*/
  line-height: 100px;
}

.box-progress-status {
  border: #1e1e33 1px solid;
  border-radius: 5px;
  min-width: 10% !important;
  width: 20%;
  max-width: 20% !important;
  line-height: 10px;
}

.required-dot {
  color: #ff0020;
  margin-right: 5px;
}

.link {
  cursor: pointer;
}

.box-padding {
  padding: 3px 5px 1px;
  color: black;
}

.status-new {
  background-color: #FFFFFF;
  color: #000c17;
}

.status-launch {
  background-color: #67C23A;
  color: #fefefe;
}

.status-original {
  background-color: #409EFF;
  color: #fefefe;
}

.status-ack {
  background-color: #E6A23C;
  color: #fefefe;
}

.status-lock {
  background-color: #F56C6C;
  color: #fefefe;
}
</style>
<style scoped>
/* 导航栏样式 */
.fixed-navbar {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: white;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
  transition: all 0.3s ease;
}

/* 导航栏固定状态样式 */
.fixed-navbar.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.15);
  animation: navbarSlideDown 0.3s ease;
}

@keyframes navbarSlideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

::v-deep .el-card__body {
  padding: 0 !important;
}

.navbar-card {
  border: none;
  border-radius: 0;
}

.navbar-content {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 60px;
  padding: 0 20px;
}

.navbar-left {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  padding: 0 10px;
}

.navbar-center {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  white-space: nowrap;
}

.navbar-right {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}

.status-label {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  text-align: center;
  border-radius: 5px;
  padding: 2px 8px;
  margin: 1px;
  border: #7d8086 1px solid;
  background-color: #FFFFFF;
  color: #000c17;
}

/* 主要内容区域样式 */
.main-page-content {
  //padding: 80px 20px 20px;
  transition: padding-top 0.3s ease;
}
</style>
